module.exports = __webpack_public_path__ + "img/warpitLogoWhite.973a5c93.svg";